<template>
<div class="chapter">
<div class="inner_page">
<a id="page_vii">
<p class="dedi"><em class="italic">In March 1959, after the failure of the revolt by the Tibetan people against their Chinese masters, the Dalai Lama, with the help of the CIA and British intelligence sources, escaped to India. A remarkable affair, and yet three years later the British masterminded an even more remarkable coup. It went something like this …</em></p>
</a><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_Dedication.vue?f16013f8